import React, { useRef} from 'react';
import '../../../assets/scss/customPagination.scss';
import { ReactComponent as ChevronLeftIcon } from '../../../assets/svg/chevron-left.svg';

const Pagination = ({ totalItems, pageSize, currentPage, onChangePage }) => {
	const totalPages = Math.ceil(totalItems / pageSize);
	const scrollContainerRef = useRef(null);

	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			onChangePage(newPage);
		}
	};

	const renderPageNumbers = (start, end) => {
		const pageNumbers = [];
		const startPage = Math.max(1, start || currentPage - 4);
		const endPage = Math.min(totalPages, end || currentPage + 4);

		for (let i = startPage; i <= endPage; i++) {
			pageNumbers.push(
				<li key={i} className={i === currentPage ? 'active' : ''}>
					<button onClick={() => handlePageChange(i)}>{i}</button>
				</li>,
			);
		}

		return pageNumbers;
	};
	const jumper = (type) => {
		if (type === 'increment') {
			handlePageChange(totalPages);
			renderPageNumbers(currentPage - 10, currentPage);
		} else {
			handlePageChange(1);
			renderPageNumbers(1, 10);
		}
	};

	if (totalItems === 0) {
		return <></>;
	}
	return (
		<ul className="deliverablesPagination" ref={scrollContainerRef}>
			<span>
				{(currentPage - 1) * pageSize + 1}-
				{currentPage * pageSize > totalItems ? totalItems : currentPage * pageSize} of{' '}
				{totalItems}
			</span>
			<li>
				<button
					onClick={jumper}
					disabled={currentPage === 1}
					className={currentPage - 4 <= 1 ? 'noDisplay' : ''}
				>
					<ChevronLeftIcon />
					<ChevronLeftIcon />
				</button>
			</li>
			<li>
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
					className={currentPage === 1 ? 'noDisplay' : ''}
				>
					<ChevronLeftIcon />
				</button>
			</li>
			{renderPageNumbers()}
			<li>
				<button
					className={`right-chevron ${currentPage === totalPages ? 'noDisplay' : ''}`}
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
				>
					<ChevronLeftIcon />
				</button>
			</li>
			<li>
				<button
					className={`right-chevron ${currentPage + 4 >= totalPages ? 'noDisplay' : ''}`}
					onClick={() => jumper('increment')}
					disabled={currentPage === totalPages}
				>
					<ChevronLeftIcon />
					<ChevronLeftIcon />
				</button>
			</li>
		</ul>
	);
};

export default Pagination;
